export default __webpack_public_path__ + "static/media/pictureinpicture.691c5e4e.png";